const modals = {
  searchParams: {
    pageNum: 1,
    pageSize: 50,
  },
  searchValue: {
    list: [],
    total: 0,
  },
  tableLoading: false,
  selectedRowKeys: [],
  selectedRows: [],
  ReservationFlag: 0, // (预约送货) 新建 【0】， 修改 【1】
  ReservationComVisible: false,
  publicShopList: [], // 订货地点
  deliverOrderListValue: {}, // 订货通知单
  deliverOrdeParmas: {}, // 订货通知单参数
  noticeModalVisible: false,
  shopCode: '',
  noticeRowKeys: [],
  caseNoticeRowKeys: [],
  // noticeRows: [],
  detailsResult: {},
  checkedTimeRange: '',
  NoticeOrderListDetails: {},
};

export default modals;
